import React from "react";
import Card from "../../ui/Card";
import Skeleton from "../../ui/Skeleton";

const TrendAnalysisSkeleton: React.FC = () => {
  return (
    <div className="space-y-2 animate-pulse">
      {/* Dynamic Header — mesma geometria da barra de título de página real
          (rounded-2xl, sem box de ícone, sem borda inferior). */}
      <div className="flex items-center justify-between gap-3 flex-wrap min-h-[52px] bg-white/70 border border-purple-200 rounded-2xl px-4 sm:px-5 py-2.5 shadow-xs">
        <div className="flex items-center gap-2">
          <Skeleton
            variant="rectangular"
            width={20}
            height={20}
            className="rounded-sm"
          />
          <div>
            <Skeleton
              variant="text"
              width={180}
              height={16}
              className="mb-1.5"
            />
            <Skeleton variant="text" width={260} height={12} />
          </div>
        </div>
        <Skeleton
          variant="rectangular"
          width={180}
          height={36}
          className="rounded-lg"
        />
      </div>

      {/* Metric Trajectories */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} className="p-3 border-purple-200">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-4">
                <Skeleton
                  variant="rectangular"
                  width={44}
                  height={44}
                  className="rounded-lg"
                />
                <Skeleton variant="text" width={140} height={16} />
              </div>
              <div className="text-right space-y-1">
                <Skeleton
                  variant="text"
                  width={60}
                  height={10}
                  className="ml-auto"
                />
                <Skeleton
                  variant="text"
                  width={40}
                  height={14}
                  className="ml-auto"
                />
              </div>
            </div>
            <div className="flex justify-between items-end mb-3">
              <div className="space-y-1">
                <Skeleton variant="text" width={80} height={10} />
                <Skeleton variant="text" width={100} height={36} />
              </div>
              <div className="flex flex-col items-end gap-1">
                <Skeleton
                  variant="rectangular"
                  width={60}
                  height={28}
                  className="rounded-lg"
                />
                <Skeleton variant="text" width={60} height={10} />
              </div>
            </div>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={56}
              className="rounded-xl"
            />
          </Card>
        ))}
      </div>

      {/* Hashtag Velocity Table */}
      <div className="space-y-2">
        <div className="flex items-center gap-4 px-2">
          <Skeleton
            variant="rectangular"
            width={36}
            height={36}
            className="rounded-xl"
          />
          <div className="space-y-1">
            <Skeleton variant="text" width={180} height={14} />
            <Skeleton variant="text" width={140} height={10} />
          </div>
        </div>
        <Card className="overflow-hidden border-purple-200 pb-2">
          <div className="p-3 space-y-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex items-center justify-between gap-2">
                <Skeleton variant="text" width="15%" height={14} />
                <Skeleton
                  variant="rectangular"
                  width="25%"
                  height={8}
                  className="rounded-full"
                />
                <Skeleton variant="text" width="10%" height={14} />
                <Skeleton
                  variant="rectangular"
                  width="14%"
                  height={22}
                  className="rounded-full"
                />
                <Skeleton variant="text" width="10%" height={14} />
              </div>
            ))}
          </div>
        </Card>
      </div>

      {/* Golden Slots */}
      <div className="space-y-2">
        <div className="flex items-center gap-4 px-2">
          <Skeleton
            variant="rectangular"
            width={36}
            height={36}
            className="rounded-xl"
          />
          <div className="space-y-1">
            <Skeleton variant="text" width={200} height={14} />
            <Skeleton variant="text" width={160} height={10} />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-2">
          {[1, 2, 3, 4, 5].map((i) => (
            <Card key={i} className="p-3 border-purple-200 min-h-[104px]">
              <Skeleton
                variant="text"
                width={60}
                height={10}
                className="mb-2"
              />
              <Skeleton
                variant="text"
                width={80}
                height={28}
                className="mb-2"
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={6}
                className="rounded-full mb-2"
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={22}
                className="rounded-lg"
              />
            </Card>
          ))}
        </div>
      </div>

      {/* Strategic Insights */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        {[1, 2].map((i) => (
          <Card key={i} className="p-3 border-purple-200">
            <div className="flex items-center gap-4 mb-3">
              <Skeleton
                variant="rectangular"
                width={40}
                height={40}
                className="rounded-lg"
              />
              <Skeleton variant="text" width={160} height={16} />
            </div>
            <div className="space-y-2">
              {[1, 2, 3].map((j) => (
                <Skeleton
                  key={j}
                  variant="rectangular"
                  width="100%"
                  height={40}
                  className="rounded-xl"
                />
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default TrendAnalysisSkeleton;
